// extracted by mini-css-extract-plugin
export default {"changePasswordContainer":"ChangePasswordPage_changePasswordContainer__3CSHD"};